import { CustomParams, Fields } from "./types";
import { DeepKey } from "./utility-types";

export const applyFields = <PostType, FieldsArray extends DeepKey<PostType>[]>(
  urlParams: URLSearchParams,
  fields?: Fields<PostType, FieldsArray>,
) => {
  if (fields && fields.length > 0) {
    const fieldsString = fields.join(",");
    urlParams.append("fields", fieldsString);
  }
};

export const applyCustomParams = (
  customParams: CustomParams,
  urlParams: URLSearchParams,
) => {
  for (const [key, value] of Object.entries(customParams)) {
    urlParams.append(key, value);
  }
};

export const checkMaxPostsPerFetch = (maxPostsPerFetch: number) => {
  if (maxPostsPerFetch < 1 || maxPostsPerFetch > 100) {
    throw new Error(
      "maxPostsPerFetch must be greater than 0 and less than 100",
    );
  }
};

export function removePageParam(url: string, paramToRemove: string): string {
  const urlObj = new URL(url);
  const params = urlObj.searchParams;
  // Remove the 'page' parameter
  params.delete(paramToRemove);
  // Return the updated URL as a string
  return urlObj.toString();
}
